import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import logo from "../images/lady.png";

export default function HydrotecShowcaseSection() {
  return (
    <section className="relative overflow-hidden bg-[#050507] text-white">
      <div className="mx-auto w-full max-w-[1800px] px-0">
        <div className="relative border-t border-white/15">
          {/* top strip */}
          <div className="flex items-center justify-between px-6 py-5 sm:px-10 lg:px-14">
            

            </div>

          
          {/* main area */}
          <div className="grid min-h-[60px] grid-cols-1 lg:grid-cols-[1.18fr_0.82fr]">
            {/* LEFT */}
            <div className="relative flex items-end overflow-hidden px-6 pt-10 sm:px-10 lg:px-14">
              {/* giant typography */}
              <div className="pointer-events-none absolute inset-0 overflow-hidden">
                <h1 className="absolute left-[-42px] top-[120px] select-none text-[170px] font-black uppercase leading-none tracking-[-0.15em] text-[#0f6d9c] sm:text-[130px] md:text-[190px] lg:text-[220px]">
                  HYDRO
                </h1>

                <h1 className="absolute left-[58px] top-[345px] select-none text-[170px] font-black uppercase leading-none tracking-[-0.15em] text-[#7ecb42] sm:left-[92px] sm:text-[130px] md:text-[190px] lg:text-[280px]">
                  TEC
                </h1>
              </div>

              {/* ambient glow */}
              <div className="absolute left-[-100px] top-[150px] h-[340px] w-[340px] rounded-full bg-[#0f6d9c]/15 blur-3xl" />
              <div className="absolute bottom-[-40px] left-[120px] h-[320px] w-[320px] rounded-full bg-[#7ecb42]/12 blur-3xl" />

              {/* visual block */}
              <div className="relative z-10 flex w-full items-end justify-center">
                <div className="relative flex h-[590px] w-full max-w-[720px] items-end justify-center overflow-hidden">
                  {/* bottom fade */}
                  <div className="absolute inset-x-0 bottom-0 z-20 h-36 bg-gradient-to-t from-[#050507] via-[#050507]/90 to-transparent" />

                  {/* center visual */}
                  <div className="relative z-10 mb-6 flex h-[430px] w-[430px] items-center justify-center rounded-full border border-white/10 bg-white/[0.04] shadow-[0_30px_100px_rgba(0,0,0,0.45)] backdrop-blur-sm">
                    <div className="absolute inset-0 rounded-full bg-[radial-gradient(circle_at_top,rgba(255,255,255,0.15),transparent_56%)]" />

                    <img
                      src={logo}
                      alt="Hydrotec"
                      className="relative z-10 w-[300px] max-w-[75%] object-contain drop-shadow-[0_18px_40px_rgba(0,0,0,0.45)]"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT */}
            <div className="relative flex items-center px-6 py-16 sm:px-10 lg:px-16">
              <div className="max-w-[520px]">
               

                <h2 className="text-4xl font-semibold leading-[1.02] tracking-[-0.04em] sm:text-5xl lg:text-[48px]">
                  Lead and grow
                </h2>

                <p className="mt-8 text-[21px] leading-[1.85] text-white/82">
                  What if you could build water infrastructure that is as
                  intelligent, resilient and future-ready as your vision? With
                  Hydrotec, you can.
                </p>

                <div className="mt-12 flex flex-wrap gap-4">
                  <Link
                    to="/contact"
                    className="inline-flex min-w-[220px] items-center justify-center bg-[#ef6b6b] px-8 py-4 text-lg font-medium text-white transition duration-300 hover:bg-[#00ffff]"
                  >
                    Contact us
                  </Link>

                  <Link
                    to="/solutions"
                    className="inline-flex min-w-[190px] items-center justify-center border border-[#00ffff] px-8 py-4 text-lg font-medium text-white transition duration-300 hover:bg-[#ef3b2d]"
                  >
                    Our solutions
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}